module.exports = __webpack_public_path__ + "img/banner2.3addc0c0.jpg";